import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ActivatedRoute, Router, RouterLink, RouterLinkActive } from "@angular/router";
import { AppResource } from "@app/app.resource";
import { TranslateModule } from "@ngx-translate/core";
import { BaseComponent } from "@shared/components/base/base.component";
import { POLICY } from "@shared/constants/route-variables.constants";
import {
  ACCUEIL,
  AUTHENTIFICATION_FORTE,
  CONDITIONS_GENERALES,
  CONNEXION,
  MAINTENANCE,
  MENTIONS_LEGALES,
  MON_PROFIL,
  MOT_DE_PASSE_OUBLIE,
  NOS_OFFRES,
  NOUS_CONTACTER,
  PAGE_NON_TROUVEE,
  PAYMENT_REQUEST,
  PREMIERE_CONNEXION,
  REGULARISATION_OFF,
} from "@shared/constants/route.constants";
import { LogoutComponent } from "@shared/layout/logout/logout.component";
import { AuthenticationService } from "@shared/services/authentication.service";
import { IdleUserService } from "@shared/services/idle-user.service";
import { isNavigationButtonVisible } from "@shared/utils/brand-utils";
import { ConfirmationService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { HeaderMobileComponent } from "./header-mobile/header-mobile.component";

@Component({
  selector: "app-header",
  standalone: true,
  templateUrl: "./header.component.html",
  providers: [ConfirmationService],
  imports: [
    CommonModule,
    ButtonModule,
    RouterLink,
    RouterLinkActive,
    ConfirmDialogModule,
    LogoutComponent,
    HeaderMobileComponent,
    TranslateModule,
  ],
})
export class HeaderComponent extends BaseComponent {
  isMenuOpen = false;

  ACCUEIL = ACCUEIL;
  MON_PROFIL = MON_PROFIL;
  NOS_OFFRES = NOS_OFFRES;
  NOUS_CONTACTER = NOUS_CONTACTER;

  constructor(
    public router: Router,
    public authService: AuthenticationService,
    public idle: IdleUserService,
    private route: ActivatedRoute,
    resources: AppResource
  ) {
    super(resources);
    this.idle.setUserIdle();
  }

  isButtonVisible(buttonType: any): boolean {
    return isNavigationButtonVisible(buttonType);
  }

  menuOpen(event: any) {
    this.isMenuOpen = event;
  }

  showMenu() {
    let excludedUrls = [
      CONNEXION,
      MOT_DE_PASSE_OUBLIE,
      PREMIERE_CONNEXION,
      AUTHENTIFICATION_FORTE,
      PAGE_NON_TROUVEE,
      REGULARISATION_OFF,
      PAYMENT_REQUEST,
    ];
    if (!this.authService.isLoggedIn()) {
      excludedUrls = [...excludedUrls, CONDITIONS_GENERALES, MENTIONS_LEGALES];
    }
    const url = this.router.url.replace("/", "");
    const queryParams = this.route.snapshot.queryParamMap;
    const policy = queryParams.get(POLICY);
    const isRegularisationRoute = this.router.url.includes(REGULARISATION_OFF);
    const isExcluded = excludedUrls.some(excludedUrl => url.includes(excludedUrl));

    return !isExcluded && !(isRegularisationRoute && policy !== null);
  }

  showHeader() {
    const excludedUrls = [MAINTENANCE];
    const url = this.router.url.replace("/", "");
    return !excludedUrls.includes(url);
  }
}